module.exports = __webpack_public_path__ + "static/media/icon_scanbody.b9490367.svg";